<template>
    <footer class="exchange-and-online-betting-sec" loading="lazy">
        <div class="remove-padding">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                    <div>
                        <div class="exchange-fair-ply-logo">
                             <img :src="siteSettings.aws_url + siteSettings.storage_path.domain_image + siteSettings.logo" alt="logo">
                           <!-- <img src="@/assets/images/website-super-winlogo.webp" alt="logo" class="web-logo" /> -->
                        </div>
                        <div class="trusted-betting-text">
                            <p>© Established in 2019, FairPlay is the most trusted betting exchange and leading online
                                casino.</p>
                        </div>
                        <div class="horizontal-line-full">
                            <hr>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-sm-3 col-md-3 col-lg-2">
                    <div class="name-of-game">
                        <h3>GAME</h3>
                        <ul>
                            <li><a href="#"> Card Game </a></li>
                            <li><a href="#"> Cricket Betting </a></li>
                            <li><a href="#"> IPL Betting </a></li>
                            <li><a href="#"> Football Betting </a></li>
                            <li><a href="#"> Tennis Betting </a></li>
                            <li><a href="#"> Live Casino Betting </a></li>
                            <li><a href="#"> Fairplay Online Betting App </a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-6 col-sm-3 col-md-2 col-lg-2">
                    <div class="name-of-game">
                        <h3>COMPANY</h3>
                        <ul>
                            <li>
                                <router-link to="/static/ABOUT_US" > About Us </router-link>
                                </li>
                            <li><a href="#"> Rules & Regulation </a></li>
                            <li>
                                <router-link to="/static/PRIVACY_POLICY" > Privacy Policy </router-link>
                            </li>
                            <li><a href="#"> Sitemap </a></li>
                            <li><a href="#"> Responsible Gambling </a></li>
                            <li><a href="#"> Terms And Conditions </a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-6 col-sm-4 col-md-2 col-lg-2">
                    <div class="name-of-game">
                        <h3>RESOURCES</h3>
                        <ul>
                            <li><a href="#"> Blogs </a></li>
                            <li>
                                <router-link to="/static/NEWS"> Fairplay News</router-link>
                            </li>
                            <li><a href="#"> Premium Sportsbook Betting </a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-6 col-sm-2 col-md-2 col-lg-1">
                    <div class="name-of-game">
                        <ul class="faq-sec">
                            <li><a href="#"> Affiliate </a></li>
                            <li>
                                <router-link to="/faqs"> FAQ </router-link>
                            </li>
                            <li>
                                <router-link to="/static/TUTORIALS"> Tutorials</router-link>
                            </li>
                            <li><a href="#"> Market </a></li>
                            <li>
                                <router-link to="/static/LOYALTY"> Loyalty </router-link>
                                </li>
                            <li><a href="#"> Contact Us </a></li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-3"  v-if="siteSettings?.social_link">
                    <div class="socail-link">
                        <ul>
                            <li v-if="siteSettings.social_link.facebook_link"><a :href="siteSettings.social_link.facebook_link" target="_blank"><img src="@/assets/images/facebook.webp" alt=""></a></li>
                            <!-- <li><a href="#"><img src="@/assets/images/twitter.webp" alt=""></a></li> -->
                            <li v-if="siteSettings.social_link.telegram_link"><a :href="siteSettings.social_link.telegram_link" target="_blank"><img src="@/assets/images/telegram.webp" alt=""></a></li>
                            <li v-if="siteSettings.social_link.instagram_link"><a :href="siteSettings.social_link.instagram_link" target="_blank"><img src="@/assets/images/instagram.webp" alt=""></a></li>
                            <li v-if="siteSettings.social_link.youtube_link"><a :href="siteSettings.social_link.youtube_link" target="_blank"><img src="@/assets/images/youtube.webp" alt=""></a></li>
                            <li v-if="siteSettings.social_link.email"><a :href="'mailto:'+ siteSettings.social_link.email" target="_blank"><img src="@/assets/images/email.webp" alt="" style="border-radius:0"></a></li>
                            <li v-if="siteSettings && siteSettings?.business_type == 2">
                                <a :href="'//wa.me/'+siteSettings.social_link.whatsappno1" target="_blank" 
                                    v-if="siteSettings.social_link.whatsappno1">
                                    <img src="@/assets/images/whatsapp.webp" alt="">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="horizontal-line-full">
                <hr>
            </div>

            <div class="gambling-involved-sec">
                <div class="disclaimer-text disclaimer-text-in-mobile" id="disclaimer-details">
                    <span>Disclaimer :</span>
                    <p>Please note that Gambling involves a financial risk and could be addictive over time if not practised
                        within limits. Only 18+ people should use the services and should use it responsibly. Players should
                        be aware of any financial risk and govern themselves accordingly.</p>
                </div>
                <div class="row">
                    <div class="col-6 col-sm-3 col-md-3 col-lg-2">
                        <!-- <div class="gaming-image">
                            <img src="@/assets/images/gc.webp" alt="">
                        </div> -->
                    </div>
                    <div class="col-6 col-sm-9 col-md-9 col-lg-10">
                        <div class="disclaimer-text">
                            <span>Disclaimer :</span>
                            <p>Please note that Gambling involves a financial risk and could be addictive over time if not
                                practised within limits. Only 18+ people should use the services and should use it
                                responsibly. Players should be aware of any financial risk and govern themselves
                                accordingly.</p>
                        </div>
                        <!-- <div class="disclaimer-box">
                            <button type="button" id="btn-18">
                                <span>18+</span>
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="horizontal-line-full last">
                <hr>
            </div>
            <div class="copy-right-sec">
                <p>© 2023 {{$store?.getters?.siteSettings?.domain_name}}. All Rights Reserved.</p>
            </div>
        </div>
    </footer>
</template>
<script>
export default{
    name:'Footer',
    computed: {
        siteSettings() {
            return this.$store.getters.siteSettings;
        },
        domainName() {
            return this.$store.getters.domainName;
        },

    },
}
</script>